import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// Issue #624 — Align inventory valuation GL statuses with the accounting rules.
//
// Manual adjustments are financial valuation movements and should be retryable
// through the inventory valuation GL bridge. Warehouse transfers stay
// non-financial because inventory remains inside the same company.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "007_inventory_valuation_status_alignment",
  version: "1.5.0",
  sql: `
    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'pending',
      \`valuation_gl_non_financial_reason\` = NULL,
      \`valuation_gl_error\` = NULL
    WHERE \`source\` = 'manual'
      AND \`entry_type\` = 'adjustment'
      AND COALESCE(\`valuation_amount\`, ABS(\`qty\` * \`rate\`), 0) > 0
      AND \`valuation_gl_status\` = 'non_financial';

    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'non_financial',
      \`valuation_gl_non_financial_reason\` = 'WAREHOUSE_TRANSFER_NO_FINANCIAL_IMPACT',
      \`valuation_gl_error\` = NULL
    WHERE \`source\` IN ('stock_transfer', 'stock_transfer_cancelled')
      AND \`valuation_gl_status\` != 'posted';
  `,
};
